import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\tbottom: 0;\n\n\tleft: 0;\n\topacity: 0;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\ttransition: opacity ", " linear;\n\n\t[data-active='true'] > & {\n\t\topacity: 1;\n\t}\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\t&[aria-expanded='true'] {\n\t\t", ";\n\t}\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: 9999px;\n\twidth: 100%;\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tcursor: pointer;\n\n\t&::before {\n\t\t", ";\n\t\tborder: 2px solid ", ";\n\t\tcontent: '';\n\t\theight: calc(100% + 8px);\n\t\tleft: -4px;\n\t\tposition: absolute;\n\t\ttop: -4px;\n\t\twidth: calc(100% + 8px);\n\t\topacity: 0;\n\t}\n\n\t&:active {\n\t\topacity: 0.6;\n\t}\n\n\t&:focus {\n\t\t&::before {\n\t\t\topacity: 1;\n\t\t}\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 20px;\n\twidth: 20px;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 30px;\n\twidth: 30px;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbox-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1) inset;\n\toutline: none;\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var ColorCircleView = styled.div(_templateObject(), ui.borderRadius.circle);
export var large = css(_templateObject2());
export var medium = css(_templateObject3());
export var small = css(_templateObject4());
export var active = css(_templateObject5());
export var interactive = css(_templateObject6(), ui.animation.default, ui.borderRadius.circle, ui.color.admin);
export var pill = css(_templateObject7());
export var expand = css(_templateObject8(), active);
export var CheckboxIconView = styled.div(_templateObject9(), ui.font.color.white, ui.alignment.content.center, ui.get('transitionDurationFastest'));